import { cn } from '@/lib/cn';

/**
 * Ankyah Nexus lockup: the triangle mark (image) beside a live-text wordmark. "Ankyah" and "Nexus"
 * share one left edge and a deliberate line gap, so the lockup stays crisp and aligned at any size.
 * Size it with a font size (e.g. `text-[15px]`); everything scales in `em`.
 */
export function Logo({ className, onDark }: { className?: string; onDark?: boolean }) {
  return (
    <span
      role="img"
      aria-label="Ankyah Nexus"
      className={cn('inline-flex items-center gap-[0.6em] text-[15px] leading-none select-none', className)}
    >
      <img
        src="/brand/ankyah-mark.png"
        alt=""
        aria-hidden
        width={256}
        height={256}
        className="size-[2.15em] shrink-0"
        draggable={false}
      />
      <span aria-hidden className="flex flex-col gap-[0.16em] font-display font-bold tracking-[-0.02em]">
        <span className={cn('leading-[0.95]', onDark ? 'text-white' : 'text-fg')}>Ankyah</span>
        <span
          className={cn(
            'bg-clip-text leading-[0.95] text-transparent',
            onDark
              ? 'bg-linear-to-r from-[#00d2d1] to-[#00b3b2]'
              : 'bg-linear-to-r from-[#00a8a7] to-[#008a8a] dark:from-[#00d2d1] dark:to-[#00b3b2]',
          )}
        >
          Nexus
        </span>
      </span>
    </span>
  );
}

export function BrandMark({ className }: { className?: string }) {
  return (
    <img
      src="/brand/ankyah-mark.png"
      alt="Ankyah Nexus"
      width={256}
      height={256}
      className={cn('size-8', className)}
      draggable={false}
    />
  );
}
